import React, { useEffect, useState } from "react";
import "./Leads.css";
import Rating from "./Rating";
import QuotationImg from './img/002-quotation.png'
import SuccessModal from "./SuccessModal";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import moment from "moment-timezone";
import { useNavigate } from "react-router-dom";
import numberToWords from 'number-to-words';


const convertToINRWords = (amount) => {
    const words = [
        "", "One", "Two", "Three", "Four", "Five", "Six", "Seven", "Eight", "Nine",
        "Ten", "Eleven", "Twelve", "Thirteen", "Fourteen", "Fifteen",
        "Sixteen", "Seventeen", "Eighteen", "Nineteen"
    ];
    const tens = ["", "", "Twenty", "Thirty", "Forty", "Fifty", "Sixty", "Seventy", "Eighty", "Ninety"];

    const numToWords = (num) => {
        if (num < 20) return words[num];
        if (num < 100) return tens[Math.floor(num / 10)] + (num % 10 !== 0 ? " " + words[num % 10] : "");
        if (num < 1000) return words[Math.floor(num / 100)] + " Hundred" + (num % 100 !== 0 ? " and " + numToWords(num % 100) : "");
        if (num < 100000) return numToWords(Math.floor(num / 1000)) + " Thousand" + (num % 1000 !== 0 ? " " + numToWords(num % 1000) : "");
        if (num < 10000000) return numToWords(Math.floor(num / 100000)) + " Lakh" + (num % 100000 !== 0 ? " " + numToWords(num % 100000) : "");
        return numToWords(Math.floor(num / 10000000)) + " Crore" + (num % 10000000 !== 0 ? " " + numToWords(num % 10000000) : "");
    };

    if (isNaN(amount)) return "";

    const wholePart = Math.floor(amount);
    const result = numToWords(wholePart);

    return `Rupees ${result} Only`;
};





const LeadsCards = ({ leads, setLeads, selectedLeads, setSelectedLeads, currentPage, newlyAssignedLeads, setNewlyAssignedLeads, alreadyAssignedLeads, setAlreadyAssignedLeads }) => {
    const [showDetails, setShowDetails] = useState({});
    const [starredLeads, setStarredLeads] = useState({});
    const [showQuotationModal, setShowQuotationModal] = useState(false);
    const [showPreviewModal, setShowPreviewModal] = useState(false);
    const [showReminderModal, setShowReminderModal] = useState(false);
    const [showNoteModal, setShowNoteModal] = useState(false);
    const [pricePerUnit, setPricePerUnit] = useState("");
    const [quantity, setQuantity] = useState(null);
    const [showGST, setShowGST] = useState(false);
    const [gst, setGst] = useState("");
    const [showDiscount, setShowDiscount] = useState(false);
    const [discount, setDiscount] = useState("");
    const [productName, setProductName] = useState("");
    const [addNote, setAddNote] = useState("");
    const [selectedDate, setSelectedDate] = useState("");
    const [selectedTime, setSelectedTime] = useState("");
    const [notes, setNotes] = useState("");
    const [clickedContact, setClickedContact] = useState(false);
    const [isModalOpen, setModalOpen] = useState(false);
    const [notesData, setNotesData] = useState([]);
    const [leadsData, setLeadsData] = useState({})
    const [leadStatus, setLeadStatus] = useState("");
    const navigate = useNavigate();
    const [showRatingPopup, setShowRatingPopup] = useState(false);
    const [selectedLeadForRating, setSelectedLeadForRating] = useState(null);
    const [showEnquiryModalEdit, setShowEnquiryModalEdit] = useState(false);
    const [customerName, setCustomerName] = useState("");
    const [businessName, setBusinessName] = useState("");
    const [address, setAddress] = useState("");
    const [city, setCity] = useState("");
    const [pincode, setPincode] = useState("");
    const [service, setService] = useState("");
    const [notes1, setNotes1] = useState("");
    const [reminderDate, setReminderDate] = useState("");
    const [reminderTime, setReminderTime] = useState("");
    const [enquirySource, setEnquirySource] = useState("");
    const [customerType, setCustomerType] = useState("new");
    const [mobile, setMobile] = useState("");
    const [email, setEmail] = useState("");
    const isLoggedIn = JSON.parse(localStorage.getItem("2xgxgshdugyywerw12gh")) || "";
    const [formData, setformData] = useState({
        id: "",
        name: "",
        mobile: "",
        business_name: "",
        address: "",
        city: "",
        pincode: "",
        related_service: "",
        remainder_time: "",
        remainder_date: "",
        type_customer: "",
        remark: "",
        age: "",
        enquiry_source: "",
        user_id: isLoggedIn.user_id
    })

    const numberToWords = (num) => {
        const a = [
            '', 'One', 'Two', 'Three', 'Four', 'Five', 'Six', 'Seven',
            'Eight', 'Nine', 'Ten', 'Eleven', 'Twelve', 'Thirteen',
            'Fourteen', 'Fifteen', 'Sixteen', 'Seventeen', 'Eighteen', 'Nineteen'
        ];
        const b = ['', '', 'Twenty', 'Thirty', 'Forty', 'Fifty', 'Sixty', 'Seventy', 'Eighty', 'Ninety'];

        const convert = (n) => {
            if (n < 20) return a[n];
            if (n < 100) return b[Math.floor(n / 10)] + (n % 10 ? ' ' + a[n % 10] : '');
            if (n < 1000) return a[Math.floor(n / 100)] + ' Hundred' + (n % 100 ? ' and ' + convert(n % 100) : '');
            if (n < 100000) return convert(Math.floor(n / 1000)) + ' Thousand' + (n % 1000 ? ' ' + convert(n % 1000) : '');
            if (n < 10000000) return convert(Math.floor(n / 100000)) + ' Lakh' + (n % 100000 ? ' ' + convert(n % 100000) : '');
            return convert(Math.floor(n / 10000000)) + ' Crore' + (n % 10000000 ? ' ' + convert(n % 10000000) : '');
        };

        return convert(Number(num));
    };

    const handleInputChange = (event) => {
        const { name, value } = event.target;
        setformData((prevData) => ({
            ...prevData,
            [name]: value,
        }));
    };


    const handleDateSelection = (date) => {
        setSelectedDate(date);
        setSelectedTime(""); // Reset time selection on date change
    };

    const openRatingPopup = (lead) => {
        setSelectedLeadForRating(lead);
        setShowRatingPopup(true);
    };

    const closeRatingPopup = () => {
        setShowRatingPopup(false);
        setSelectedLeadForRating(null);
    };

    const openEnquiryModalEdit = () => {
        setShowEnquiryModalEdit(true);
    };

    const closeEnquiryModalEdit = () => {
        setShowEnquiryModalEdit(false);
        // fetchLeadsData();
    };

    const getRelativeTime = (timestamp) => {
        if (!timestamp) return "Not Available";

        let parsed;

        // 🔹 Case 1: If it's a number or millisecond timestamp
        if (!isNaN(timestamp)) {
            parsed = moment(Number(timestamp)).tz("Asia/Kolkata");
        } else {
            // 🔹 Case 2: Custom string format like "24/3/2025, 5:15:01 pm"
            parsed = moment(timestamp, "D/M/YYYY, h:mm:ss a").tz("Asia/Kolkata");
        }

        if (!parsed.isValid()) return "Invalid Date";

        const now = moment().tz("Asia/Kolkata");
        const duration = moment.duration(now.diff(parsed));

        if (duration.asSeconds() < 10) {
            return "Just now"; // 🔸 For milliseconds or very recent time
        } else if (duration.asSeconds() < 60) {
            const seconds = Math.floor(duration.asSeconds());
            return `${seconds} second${seconds === 1 ? "" : "s"} ago`;
        } else if (duration.asMinutes() < 60) {
            const minutes = Math.floor(duration.asMinutes());
            return `${minutes} minute${minutes === 1 ? "" : "s"} ago`;
        } else if (duration.asHours() < 24) {
            const hours = Math.floor(duration.asHours());
            return `${hours} hour${hours === 1 ? "" : "s"} ago`;
        } else if (duration.asDays() < 7) {
            const days = Math.floor(duration.asDays());
            return `${days} day${days === 1 ? "" : "s"} ago`;
        } else if (duration.asWeeks() < 4) {
            const weeks = Math.floor(duration.asWeeks());
            return `${weeks} week${weeks === 1 ? "" : "s"} ago`;
        } else if (duration.asMonths() < 12) {
            const months = Math.floor(duration.asMonths());
            return `${months} month${months === 1 ? "" : "s"} ago`;
        } else {
            const years = Math.floor(duration.asYears());
            return `${years} year${years === 1 ? "" : "s"} ago`;
        }
    };



    const openQuotationModal = (lead) => {
        setShowQuotationModal(true);
        setLeadsData(lead);
    };

    const closeQuotationModal = () => {
        setShowQuotationModal(false);
    };

    const openPreviewModal = () => {
        setShowPreviewModal(true);
    };

    const closePreviewModal = () => {
        setShowPreviewModal(false);
    };

    const openReminderModal = () => {
        setShowReminderModal(true);
    }

    const closeReminderModal = () => {
        setShowReminderModal(false);
    }

    const openNoteModal = (lead) => {
        setShowNoteModal(true);
        setLeadsData(lead);
    };

    const closeNoteModal = () => {
        setShowNoteModal(false);
    };


    const handleClickContact = () => {
        setClickedContact(true);
    };


    // Handle selection of individual leads
    // const handleSelectLead = (id) => {
    //     setSelectedLeads(prevSelected => {
    //         const updatedSelections = prevSelected[currentPage] ? [...prevSelected[currentPage]] : [];

    //         if (updatedSelections.includes(id)) {
    //             // Remove if already selected
    //             return {
    //                 ...prevSelected,
    //                 [currentPage]: updatedSelections.filter(leadId => leadId !== id),
    //             };
    //         } else {
    //             // Add if not selected
    //             return {
    //                 ...prevSelected,
    //                 [currentPage]: [...updatedSelections, id],
    //             };
    //         }
    //     });
    // };

    const handleSelectLead = (id) => {
        setSelectedLeads(prevSelected => {
            const updatedSelections = prevSelected[currentPage] ? [...prevSelected[currentPage]] : [];

            if (updatedSelections.includes(id)) {
                // ✅ Remove color from newly assigned leads when deselected
                setNewlyAssignedLeads((prev) => prev.filter((leadId) => leadId !== id));
                setAlreadyAssignedLeads((prev) => prev.filter((leadId) => leadId !== id));

                return {
                    ...prevSelected,
                    [currentPage]: updatedSelections.filter(leadId => leadId !== id),
                };
            } else {
                return {
                    ...prevSelected,
                    [currentPage]: [...updatedSelections, id],
                };
            }
        });
    };

    const toggleSelection = (id) => {
        setSelectedLeads((prevSelected) =>
            prevSelected.includes(id)
                ? prevSelected.filter(leadId => leadId !== id) // Remove if already selected
                : [...prevSelected, id] // Add if not selected
        );
    };


    // Handle Select All functionality
    useEffect(() => {
        if (selectedLeads.length === leads.length && leads.length > 0) {
            setSelectedLeads(leads.map(lead => lead.id)); // Select all
        }
    }, [leads]);



    const toggleDetails = (id) => {
        setShowDetails((prev) => ({ ...prev, [id]: !prev[id] }));
    };

    // const toggleStarred = (id) => {
    //     setStarredLeads((prev) => ({ ...prev, [id]: !prev[id] }));
    // };

    const toggleStarred = async (lead) => {
        try {
            const response = await fetch(`https://100billionoms.com/leads/toggle-starred/${lead.id}`, {
                method: "PUT",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ star: !lead.star }), // Toggle the starred value
            });

            if (response.ok) {
                const updatedLead = await response.json();
                // Update state to reflect the change
                setLeads((prevLeads) =>
                    prevLeads.map((l) => (l.id === lead.id ? { ...l, star: updatedLead.star } : l))
                );
            }
        } catch (error) {
            console.error("Error updating starred status:", error);
        }
    };


    // Calculate total amount
    const calculateTotal = () => {
        let basePrice = pricePerUnit;
    
        let discountAmount = 0;
        if (showDiscount && discount > 0) {
            discountAmount = (basePrice * discount) / 100;
        }
    
        let gstAmount = 0;
        if (showGST && gst > 0) {
            gstAmount = (basePrice * gst) / 100;
        }
    
        const total = (basePrice - discountAmount) + gstAmount;
    
        return total.toFixed(2);
    };
    

    const handleContactClick = async (lead, contactType) => {
        try {
            const response = await fetch(`https://100billionoms.com/leads/update-mark/${lead.id}`, {
                method: "PUT",
                headers: {
                    "Content-Type": "application/json",
                }
            });


            if (response.ok) {
                fetchLeads();
            }
            // Redirect based on contact type
            if (contactType === "phone") {
                window.location.href = `tel:${lead.mobile}`;
            } else if (contactType === "whatsapp") {
                const whatsappNumber = lead.mobile.replace(/\D/g, ""); // Ensure only numbers
                window.open(`https://wa.me/${whatsappNumber}`, "_blank");
            } else if (contactType === "email") {
                window.location.href = `mailto:${lead.age}`;
            }

        } catch (error) {
            console.error("Error updating mark:", error);
        }
    };

    const fetchLeads = async () => {
        try {
            const response = await fetch(`https://100billionoms.com/leads/all/${isLoggedIn.user_id}`);
            const data = await response.json();
            setLeads(data.reverse());
        } catch (error) {
            console.error("Error fetching leads:", error);
        }
    };

    const convertToIST = (utcDateString) => {
        if (!utcDateString) return "Invalid Date";

        const date = new Date(utcDateString);
        return date.toLocaleString("en-IN", {
            timeZone: "Asia/Kolkata",
            // day: "2-digit",
            // month: "short",
            // year: "numeric",
            hour: "2-digit",
            minute: "2-digit",
            second: "2-digit",
            hour12: true
        });
    };

    const convertToISTUtc = (utcDateString) => {
        if (!utcDateString) return "Invalid Date";

        const date = new Date(utcDateString);
        return date.toLocaleString("en-IN", {
            timeZone: "Asia/Kolkata",
            day: "2-digit",
            month: "short",
            year: "numeric",
            hour: "2-digit",
            minute: "2-digit",
            second: "2-digit",
            hour12: true
        });
    };

    const convertToISTMain = (utcDateString) => {
        if (!utcDateString) return "Invalid Date";

        const date = new Date(utcDateString);
        return date.toLocaleString("en-IN", {
            timeZone: "Asia/Kolkata",
            // day: "2-digit",
            // month: "short",
            // year: "numeric",
            hour: "2-digit",
            minute: "2-digit",
            // second: "2-digit",
            hour12: true
        });
    };

    const handleNotesSubmit = async () => {
        try {
            const response = await fetch(`https://100billionoms.com/note`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({
                    remark: notes,
                    property_id: leadsData.id,
                    property: leadsData.business_name,
                    phone: "Admin",
                })
            })
            if (response.ok) {
                const res = await response.json();
                setNotes("")
                fetchNotes(leadsData.id);
                // closeNoteModal();
                toast.success("Note added successfully");
            }
        } catch (error) {
            toast.error(error);
        }
    }

    const fetchNotes = async (id) => {
        try {
            const response = await fetch(`https://100billionoms.com/note/all/${Number(id)}`);
            const res = await response.json();
            setNotesData(res.reverse());
        } catch (error) {
            toast.error("Error fetching notes", {
                position: "top-center",
                autoClose: 2000,
            })
        }
    }

    const handleStatusChange = async (newStatus, lead) => {
        try {
            const response = await fetch(`https://100billionoms.com/leads/change/${lead.id}`, {
                method: "PUT",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({ extra: newStatus }) // send only the updated field
            });

            if (response.ok) {
                toast.success("Status updated successfully");

                // ✅ Update the lead in local state
                setLeads(prev =>
                    prev.map(item =>
                        item.id === lead.id ? { ...item, extra: newStatus } : item
                    )
                );
            } else {
                const err = await response.json();
                toast.error(err.message || "Failed to update status");
            }
        } catch (err) {
            console.error("Error updating status:", err);
            toast.error("An error occurred while updating status");
        }
    };

    const handleSendQuotation = async () => {
        const payload = {
            user_id: leadsData.id,
            user_name: leadsData.name,
            service_name: productName,
            quantity,
            price_per_unit: pricePerUnit,
            gst,
            discount,
            notes: addNote,
            staff_name: "Admin",
            total_amount: calculateTotal(),
        };

        try {
            const response = await fetch("https://100billionoms.com/quotation", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(payload),
            });

            const data = await response.json();
            if (response.ok) {
                handleWhatsAppSend(payload)
                toast.success("Quotation sent and saved successfully!");
                // Optionally close modal or reset fields

            } else {
                toast.error(data.message || "Failed to send quotation.");
            }
        } catch (err) {
            console.error("Error sending quotation:", err);
            toast.error("Something went wrong while sending the quotation.");
        }
    };

    const handleWhatsAppSend = (lead) => {
        const totalFormatted = `₹${calculateTotal().toLocaleString("en-IN")}`;

        const message = `
      Dear ${lead.user_name},
      Greetings from Bhoomi Solutions!
      
      Here's the information you requested:
      
      • Building/Project Name: ${lead.service_name}
      • Carpet Area: ${lead.quantity} sq.ft
      • Total Price: ${totalFormatted}
      • Note: ${lead.notes}
     
      
      Thank you!
        `.trim();

        const phone = leadsData.mobile.replace(/\D/g, "");
        const fullPhone = phone.startsWith("91") ? phone : `91${phone}`;
        const encodedMessage = encodeURIComponent(message);

        const url = `https://api.whatsapp.com/send?phone=${fullPhone}&text=${encodedMessage}`;

        window.open(url, "_blank");
    };





    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const response = await fetch(`https://100billionoms.com/leads/change/${formData.id}`, {
                method: "PUT",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify(formData)
            })
            const res = await response.json();
            if (response.ok) {
                fetchLeads();
                closeEnquiryModalEdit();
            }
        } catch (error) {
            toast.error("Error updating lead", {
                position: "top-center",
                autoClose: 2000,
            })
        }
    }


    useEffect(() => {

    }, [newlyAssignedLeads]);


    useEffect(() => {
        fetchNotes();
    }, [])



    return (
        <>
            {/* <div className="flex flex-col items-center justify-center h-screen">
      <button 
        className="bg-green-500 text-white px-4 py-2 rounded-lg"
        onClick={() => setModalOpen(true)}
      >
        Show Modal
      </button>

      <SuccessModal isOpen={isModalOpen} onClose={() => setModalOpen(false)} />
    </div> */}
            {leads.map((lead) => (
                <div className={`card-rating `}>
                    <div className={`ls-card ${lead.mark === "New" ? "new-leadhbtleads" : ""}
    ${alreadyAssignedLeads.includes(lead.id) ? "already-assigned" : ""} 
    ${newlyAssignedLeads.includes(lead.id) ? "" : ""}`}
                        key={lead.id}
                    >

                        <div className="ls-card-header">


                            <div className="read-time">
                                <div className="newdivafterupdatecheckbox">
                                    <div className="select-lead-checkbox">
                                        <input
                                            type="checkbox"
                                            checked={selectedLeads[currentPage]?.includes(lead.id) || false}
                                            onChange={() => handleSelectLead(lead.id)}
                                        />

                                    </div>
                                    <span className={`ls-badge ${lead.mark === "Read" ? "ls-read" : "ls-unread"}`}>
                                        {lead.mark}
                                    </span>

                                </div>


                                <span className="ls-time">{convertToIST(lead.createdAt)}</span>
                            </div>


                            <div className="ls-detail-contact">
                                <div className="ls-details">
                                    <h3 className="ls-title" onClick={() => toggleStarred(lead)}>
                                        <i
                                            className={lead.star ? "fa-solid fa-star starred" : "fa-regular fa-star unstarred"}
                                        ></i>
                                        {(lead.name === "" || lead.name === null) ? lead.business_name : lead.name}
                                    </h3>
                                    <p className="ls-location">{lead.address}</p>
                                    <p className="ls-category">{lead.related_service}</p>
                                    <p className="ls-date">{convertToISTUtc(lead.createdAt)}</p>
                                    {
                                        (lead.staff_id && lead.staff_name) ? <p className="ls-date">Assigned to: {lead.staff_name}-{lead.staff_id}</p> : null
                                    }
                                    {
                                        (lead.remark) ? <p className="ls-date">Message: {lead.remark}</p> : null
                                    }
                                </div>
                                <div className="ls-contact-icons">
                                    {
                                        lead.mobile ? <a
                                            href="#"
                                            className={`ls-card-icon ls-call ${clickedContact ? "clicked" : ""}`}
                                            onClick={(e) => {
                                                e.preventDefault();
                                                handleContactClick(lead, "phone");
                                            }}
                                        >
                                            <i className="fas fa-phone"></i>
                                        </a> : null
                                    }

                                    {
                                        lead.mobile ? <a
                                            href='#'
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            className={`ls-card-icon ls-whatsapp ${clickedContact ? "clicked" : ""}`}
                                            onClick={(e) => {
                                                e.preventDefault();
                                                handleContactClick(lead, "whatsapp");
                                            }}
                                        >
                                            <i className="fab fa-whatsapp"></i>
                                        </a> : null
                                    }

                                    {
                                        lead.age ? <a
                                            href={'#'}
                                            className={`ls-card-icon ls-mail ${clickedContact ? "clicked" : ""}`}
                                            onClick={(e) => {
                                                e.preventDefault();
                                                handleContactClick(lead, "email");
                                            }}
                                        >
                                            <i className="fas fa-envelope"></i>
                                        </a> : null
                                    }
                                </div>
                            </div>
                        </div>

                        {showDetails[lead.id] && (
                            <div className="ls-content">
                                <div className="ls-actions">
                                    <button className="ls-btn ls-note" onClick={() => {
                                        openNoteModal(lead)

                                        fetchNotes(lead.id)
                                    }}>➕ Add Note</button>
                                    {/* <button className="ls-btn ls-reminder" onClick={() => openReminderModal()}>⏰ Add Reminder</button> */}
                                    <button className="ls-btn ls-rating" onClick={() => openRatingPopup(lead)}>⭐ Ask Rating</button>
                                    <select
                                        name="extra"
                                        value={lead.extra || ""}
                                        id="status"
                                        className="ls-status"
                                        onChange={(e) => handleStatusChange(e.target.value, lead)}
                                    >
                                        <option value="">Select</option>
                                        <option value="Pending">Pending</option>
                                        <option value="Cancelled">Cancelled</option>
                                        <option value="Converted">Converted</option>
                                        <option value="Not Interested">Not Interested</option>
                                        <option value="In Process">In Process</option>
                                    </select>
                                    <button className="ls-btn ls-rating" onClick={() => {
                                        setformData({
                                            id: lead.id,
                                            name: lead.name,
                                            mobile: lead.mobile,
                                            business_name: lead.business_name,
                                            address: lead.address,
                                            city: lead.city,
                                            pincode: lead.pincode,
                                            related_service: lead.related_service,
                                            remainder_date: lead.remainder_date,
                                            remainder_time: lead.remainder_time,
                                            type_customer: lead.type_customer,
                                            remark: lead.remark,
                                            age: lead.age,
                                            enquiry_source: lead.enquiry_source,
                                        })
                                        setShowEnquiryModalEdit(true)
                                    }}>
                                        <i style={{ fontSize: "15px" }} className="fa-solid fa-pen-to-square"></i> Edit
                                    </button>

                                </div>


                                {
                                    lead.enquiry_source ? <p style={{ cursor: "pointer" }} onClick={() => window.open(lead.source, "_blank")}
                                        className="ls-enquiry">
                                        Source:
                                        <strong> {lead.enquiry_source}</strong>
                                    </p> : null
                                }
                                {
                                    lead.role ? (
                                        <p className="ls-enquiry">
                                            Budget:
                                            <strong> {numberToWords(lead.role)}</strong>
                                        </p>
                                    ) : null
                                }

                                {
                                    lead.school ? <p className="ls-enquiry">
                                        Service:
                                        <strong> {lead.school.charAt(0).toUpperCase() + lead.school.slice(1)}</strong>
                                    </p> : null
                                }
                                <div className="ls-card-footer">
                                    <button className="ls-btn ls-quotation" onClick={() => {
                                        openQuotationModal(lead)


                                    }}>Send Quotation <i class="fa-solid fa-angles-right"></i></button><br />
                                </div>
                            </div>
                        )}

                        <div className="ls-toggle-last-updates">
                            <div
                                className="ls-toggle-details"
                                onClick={() => toggleDetails(lead.id)}
                            >
                                {showDetails[lead.id] ? "Hide details" : "Show details"}
                            </div>
                            {
                                lead.connected_time ? <p className="ls-connected">Connected {getRelativeTime(lead.connected_time)}</p> : null
                            }


                        </div>
                    </div>
                    <Rating inquiryId={lead.id} />
                </div>
            ))}

            {showRatingPopup && selectedLeadForRating && (
                <div className="ls-modal">
                    <div className="ls-modal-content">
                        <div className="quotation-header">
                            <h2>Send Rating Request</h2>
                            <button className="quotation-close" onClick={closeRatingPopup}>
                                <i className="fa-solid fa-xmark"></i>
                            </button>
                        </div>
                        <p>Choose how you'd like to request a rating from <strong>{selectedLeadForRating.name}</strong>:</p>

                        <div className="rating-options">
                            <button
                                className="whatsapp-btn"
                                onClick={() => {
                                    const message = `Hi ${selectedLeadForRating.name},
We would greatly appreciate your valuable feedback.
Please take a moment to leave us a review on Google:
👉 https://www.google.com/search?sca_esv=cd4fb26d11f6ea98&rlz=1C1ONGR_enIN1019IN1019&sxsrf=AHTn8zoHzPdqKh3n6ieHq2eZStA4HOAReg:1742803165163&si=APYL9bs7Hg2KMLB-4tSoTdxuOx8BdRvHbByC_AuVpNyh0x2KzZmPkh713pUtslP0t7vU08JlwYFmGTsjIycCxrBLEPFqJDRCMr1an8Qd3tzIVaBM7M6X8Kj4tSW-X2TjscoBKAj0PRdvdAMzuqpbDl-nrGcvKJazwA%3D%3D&q=Bhoomi+Solutions+Reviews&sa=X&ved=2ahUKEwj2usrcn6KMAxUhQ2cHHQJPI18Q0bkNegQILBAE&biw=1536&bih=695&dpr=1.25#lrd=0x3be7b778d82f5c83:0xc067a2a98f635275,3,,,,

Thank you for your support!`;
                                    const phone = selectedLeadForRating.mobile.replace(/\D/g, "");
                                    const url = `https://wa.me/91${phone}?text=${encodeURIComponent(message)}`;
                                    window.open(url, "_blank");
                                    closeRatingPopup();
                                }}
                            >
                                <i className="fab fa-whatsapp"></i> WhatsApp
                            </button>

                            <button
                                className="sms-btn"
                                onClick={() => {
                                    const smsBody = `Hi ${selectedLeadForRating.name},
We would greatly appreciate your valuable feedback.
Please take a moment to leave us a review on Google:
👉 https://www.google.com/search?sca_esv=cd4fb26d11f6ea98&rlz=1C1ONGR_enIN1019IN1019&sxsrf=AHTn8zoHzPdqKh3n6ieHq2eZStA4HOAReg:1742803165163&si=APYL9bs7Hg2KMLB-4tSoTdxuOx8BdRvHbByC_AuVpNyh0x2KzZmPkh713pUtslP0t7vU08JlwYFmGTsjIycCxrBLEPFqJDRCMr1an8Qd3tzIVaBM7M6X8Kj4tSW-X2TjscoBKAj0PRdvdAMzuqpbDl-nrGcvKJazwA%3D%3D&q=Bhoomi+Solutions+Reviews&sa=X&ved=2ahUKEwj2usrcn6KMAxUhQ2cHHQJPI18Q0bkNegQILBAE&biw=1536&bih=695&dpr=1.25#lrd=0x3be7b778d82f5c83:0xc067a2a98f635275,3,,,,

Thank you for your support!`;
                                    window.open(`sms:${selectedLeadForRating.mobile}?body=${encodeURIComponent(smsBody)}`);
                                    closeRatingPopup();
                                }}
                            >
                                <i className="fas fa-sms"></i> Message
                            </button>

                            {
                                selectedLeadForRating.age ? <button
                                    className="email-btn"
                                    onClick={() => {
                                        const subject = "We’d love your feedback!";
                                        const body = `Hi ${selectedLeadForRating.name},
\n\nWe would greatly appreciate your valuable feedback.
Please take a moment to leave us a review on Google:
👉 https://www.google.com/search?sca_esv=cd4fb26d11f6ea98&rlz=1C1ONGR_enIN1019IN1019&sxsrf=AHTn8zoHzPdqKh3n6ieHq2eZStA4HOAReg:1742803165163&si=APYL9bs7Hg2KMLB-4tSoTdxuOx8BdRvHbByC_AuVpNyh0x2KzZmPkh713pUtslP0t7vU08JlwYFmGTsjIycCxrBLEPFqJDRCMr1an8Qd3tzIVaBM7M6X8Kj4tSW-X2TjscoBKAj0PRdvdAMzuqpbDl-nrGcvKJazwA%3D%3D&q=Bhoomi+Solutions+Reviews&sa=X&ved=2ahUKEwj2usrcn6KMAxUhQ2cHHQJPI18Q0bkNegQILBAE&biw=1536&bih=695&dpr=1.25#lrd=0x3be7b778d82f5c83:0xc067a2a98f635275,3,,,,

Thank you for your support!`;
                                        window.location.href = `mailto:${selectedLeadForRating.age}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
                                        closeRatingPopup();
                                    }}
                                >
                                    <i className="fas fa-envelope"></i> Email
                                </button> : null
                            }
                        </div>
                    </div>
                </div>
            )}


            {showQuotationModal && (
                <div className="quotation-modal">
                    <div className="quotation-container">
                        <div className="quotation-header">
                            <h2>Generate and Send Quotation</h2>
                            <button className="quotation-close" onClick={() => setShowQuotationModal(false)}><i className="fa-solid fa-xmark"></i></button>
                        </div>
                        <div className="quotation-content">
                            <div className="quotation-input-grp">
                                <input
                                    type="text"
                                    value={productName}
                                    onChange={(e) => setProductName(e.target.value)}
                                    placeholder="Enter Project/Building Name"
                                />
                            </div>
                            <div className="quotation-input-flex">
                                <div className="quotation-input-grp quotation-price-per-unit">
                                    <label htmlFor="quotation-price-per-unit">Flat Price</label>
                                    <input
                                        type="number"
                                        name="quotation-price-per-unit"
                                        value={pricePerUnit}
                                        placeholder="₹1000"
                                        onChange={(e) => {
                                            const value = e.target.value;
                                            setPricePerUnit(value === "" ? "" : Number(value));
                                        }}
                                    // onChange={(e) => setPricePerUnit(Number(e.target.value))}
                                    />
                                    {
                                        pricePerUnit > 0 &&
                                        <small style={{ fontSize: "12px", color: "#3399ff", fontWeight: "600", marginTop: "3px" }}>
                                            {convertToINRWords(pricePerUnit)}
                                        </small>
                                    }
                                </div>
                                <div className="quotation-input-grp quotation-quantity">
                                    <label htmlFor="quotation-quantity">Carpet Area</label>
                                    <input
                                        type="number"
                                        name="quotation-quantity"
                                        value={quantity}
                                        onChange={(e) => {
                                            const value = e.target.value;
                                            setQuantity(value === "" ? "" : Number(value));
                                        }}
                                    />

                                </div>
                            </div>
                            <div className="quotation-input-flex">
                                <div className="quotation-input-grp">
                                    <div className="quotation-toggle">
                                        <label>Add GST (%)</label>
                                        <span className="quotation-toggle-icon" onClick={() => setShowGST(!showGST)}>
                                            <i className={`fas ${showGST ? 'fa-toggle-on' : 'fa-toggle-off'}`}></i>
                                        </span>
                                    </div>
                                    {showGST &&
                                        <input
                                            type="number"
                                            placeholder="GST %"
                                            value={gst}
                                            onChange={(e) => {
                                                const value = e.target.value;
                                                setGst(value === "" ? "" : Number(value));
                                            }}

                                        />
                                    }
                                </div>
                                <div className="quotation-input-grp">
                                    <div className="quotation-toggle">
                                        <label>Add Discount (%)</label>
                                        <span className="quotation-toggle-icon" onClick={() => setShowDiscount(!showDiscount)}>
                                            <i className={`fas ${showDiscount ? 'fa-toggle-on' : 'fa-toggle-off'}`}></i>
                                        </span>
                                    </div>
                                    {showDiscount &&
                                        <input
                                            type="number"
                                            placeholder="Discount %"
                                            value={discount}
                                            onChange={(e) => {
                                                const value = e.target.value;
                                                setDiscount(value === "" ? "" : Number(value));
                                            }}

                                        />
                                    }
                                </div>
                            </div>
                            <div className="quotation-input-grp">
                                <input
                                    type="text"
                                    value={addNote}
                                    onChange={(e) => setAddNote(e.target.value)}
                                    placeholder="Add notes"
                                />
                            </div>

                            <div className="quotation-footer">
                                <p className="quotation-total-amt">
                                    <div>Total Amount:</div>
                                    <div>₹{calculateTotal()}</div>
                                </p>
                                <div className="quotation-preview">
                                    <button onClick={() => openPreviewModal()}><i className="fa-solid fa-eye"></i>Preview quote</button>
                                </div>
                                <div onClick={handleSendQuotation} className="quotation-whatsapp">
                                    <button><i className="fa-brands fa-whatsapp"></i>WhatsApp</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}


            {showPreviewModal && (
                <div className="preview-modal">
                    <div className="preview-container">
                        <div className="quotation-header">
                            <h2>Quotation preview</h2>
                            <button className="quotation-close" onClick={closePreviewModal}>
                                <i className="fa-solid fa-xmark"></i>
                            </button>
                        </div>
                        <div className="chat-message">
                            <p>
                                Dear <strong>Name</strong>,<br />
                                Greetings from <strong>Bhoomi Solutions</strong>!<br />
                                Here's the information you requested:<br />
                                <strong>Project / Building Name:</strong>{productName}<br />
                                <strong>Carpet Area:</strong> {quantity}<br />
                                <strong>Note:</strong>{addNote}<br />
                                <strong>Total Price:</strong> ₹{calculateTotal()}
                            </p>
                        </div>
                        <div className="quotation-footer">
                            <div className="quotation-preview edit-quotation">
                                <button onClick={closePreviewModal}><i className="fa-solid fa-pencil"></i>Edit quote</button>
                            </div>
                            <div className="quotation-whatsapp" onClick={handleSendQuotation} >
                                <button><i className="fa-brands fa-whatsapp"></i> WhatsApp</button>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {showReminderModal && (
                <div className="ls-modal">
                    <div className="ls-modal-content">
                        <div className="quotation-header">
                            <h2>Set reminder</h2>
                            <button className="quotation-close" onClick={closeReminderModal}>
                                <i className="fa-solid fa-xmark"></i>
                            </button>
                        </div>
                        <h2>Select Date</h2>

                        {/* Date Selection */}
                        <div className="ls-modal-options">
                            <label className={`ls-radio-option ${selectedDate === "today" ? "selected" : ""}`} onClick={() => handleDateSelection("today")}>
                                Today
                            </label>

                            <label className={`ls-radio-option ${selectedDate === "tomorrow" ? "selected" : ""}`} onClick={() => handleDateSelection("tomorrow")}>
                                Tomorrow
                            </label>

                            <label className={`ls-radio-option ${selectedDate === "pick-date" ? "selected" : ""}`} onClick={() => handleDateSelection("pick-date")}>
                                Pick a Date
                            </label>
                        </div>

                        {/* Show Time Options for Today */}
                        {selectedDate === "today" && (
                            <div className="ls-time-options">
                                <h3>Select Time</h3>
                                <div className="ls-modal-options">
                                    <label className={`ls-radio-option ${selectedTime === "30min" ? "selected" : ""}`} onClick={() => setSelectedTime("30min")}>
                                        In 30 minutes
                                    </label>
                                    <label className={`ls-radio-option ${selectedTime === "2hours" ? "selected" : ""}`} onClick={() => setSelectedTime("2hours")}>
                                        In 2 hours
                                    </label>
                                    <label className={`ls-radio-option ${selectedTime === "custom" ? "selected" : ""}`} onClick={() => setSelectedTime("custom")}>
                                        Pick a Time
                                    </label>
                                </div>
                            </div>
                        )}

                        {/* Show Time Options for Tomorrow */}
                        {selectedDate === "tomorrow" && (
                            <div className="ls-time-options">
                                <h3>Select Time</h3>
                                <div className="ls-modal-options">
                                    <label className={`ls-radio-option ${selectedTime === "10am" ? "selected" : ""}`} onClick={() => setSelectedTime("10am")}>
                                        10:00 AM
                                    </label>
                                    <label className={`ls-radio-option ${selectedTime === "2pm" ? "selected" : ""}`} onClick={() => setSelectedTime("2pm")}>
                                        2:00 PM
                                    </label>
                                    <label className={`ls-radio-option ${selectedTime === "custom" ? "selected" : ""}`} onClick={() => setSelectedTime("custom")}>
                                        Pick a Time
                                    </label>
                                </div>
                            </div>
                        )}

                        {/* Custom Time Picker */}
                        {selectedTime === "custom" && (
                            <div className="ls-time-picker">
                                <input type="time" onChange={(e) => setSelectedTime(e.target.value)} />
                            </div>
                        )}

                        {selectedDate === "pick-date" && (
                            <div className="ls-date-picker">
                                <input type="date" name="" id="" />
                            </div>
                        )}

                        <div className="ls-modal-action">
                            <button className="ls-modal-cancel" onClick={closeReminderModal}>Cancel</button>
                            <button className="ls-apply-btn" onClick={closeReminderModal}>Apply</button>
                        </div>
                    </div>
                </div>
            )}


            {showNoteModal && (
                <div className="ls-modal ls-modal-note">
                    <div className="ls-modal-content">
                        <div className="quotation-header">
                            <h2>Set note</h2>
                            <button className="quotation-close" onClick={closeNoteModal}>
                                <i className="fa-solid fa-xmark"></i>
                            </button>
                        </div>
                        {/* <form > */}
                        <div className="ls-modal-options">
                            <textarea
                                placeholder="Write notes..."
                                name="notes"
                                value={notes}
                                onChange={(e) => setNotes(e.target.value)}
                            ></textarea>
                        </div>
                        <div className="ls-modal-action">
                            <button className="ls-modal-cancel" onClick={closeNoteModal}>Cancel</button>
                            <button type="submit" className="ls-apply-btn" onClick={handleNotesSubmit}>Add notes</button>
                        </div>
                        {/* </form> */}
                        {
                            notesData.length > 0 ? <div className="recorded-notes">
                                <div className="quotation-header">
                                    <h2>Recorded notes</h2>
                                </div>
                                <div className="recorded-note-lists">
                                    {notesData.map((ele, idx) => {
                                        const formattedDate = new Date(ele.createdAt).toLocaleString("en-IN", {
                                            timeZone: "Asia/Kolkata",
                                            day: "2-digit",
                                            month: "short",
                                            year: "numeric",
                                            hour: "2-digit",
                                            minute: "2-digit",
                                            second: "2-digit",
                                            hour12: true
                                        });
                                        return (
                                            <div className="recorded-note-items">
                                                <p className="recorded-note-date-time">
                                                    {formattedDate} (
                                                    {ele.phone === "Admin" ? "Admin" : ele.user_name}
                                                    )
                                                </p>

                                                <p className="recorder-note-content">
                                                    {ele.remark}
                                                </p>
                                            </div>
                                        )
                                    })}



                                </div>
                            </div> : null
                        }
                    </div>
                </div>
            )}


            {
                showEnquiryModalEdit && (
                    <div className="ls-enquiry-modal">
                        <div className="ls-enquiry-modal-content">
                            <div className="quotation-header">
                                <h2><i className="fa-solid fa-envelope"></i> New Enquiry</h2>
                                <button className="quotation-close" onClick={closeEnquiryModalEdit}>
                                    <i className="fa-solid fa-xmark"></i>
                                </button>
                            </div>
                            <form onSubmit={handleSubmit}>
                                <div className="ls-form-group">
                                    <label>Customer/Business Owner Name</label>
                                    <input type="text" name="name" placeholder="Enter full name" value={formData.name} onChange={handleInputChange} />
                                </div>
                                <div className="ls-form-group">
                                    <label>Mobile Number*</label>
                                    <input
                                        type="text"
                                        name="mobile"
                                        placeholder="Enter mobile number"
                                        value={formData.mobile}
                                        onChange={handleInputChange}
                                        required
                                    />
                                    {mobile.length > 0 && mobile.length < 10 && (
                                        <p style={{ color: "red", fontSize: "12px" }}>Mobile number must be 10 digits</p>
                                    )}
                                </div>

                                <div className="ls-form-group">
                                    <label>Email</label>
                                    <input type="email" name="age" placeholder="Enter email address" value={formData.age} onChange={handleInputChange} />
                                </div>
                                <div className="ls-form-group">
                                    <label>Business Name</label>
                                    <input type="text" name="business_name" placeholder="Enter business name" value={formData.business_name} onChange={handleInputChange} />
                                </div>

                                <div className="ls-form-group">
                                    <label>Address</label>
                                    <input type="text" name="address" placeholder="Enter address" value={formData.address} onChange={handleInputChange} />
                                </div>

                                <div className="ls-form-row">
                                    <div className="ls-form-group">
                                        <label>City</label>
                                        <input type="text" name="city" placeholder="Enter city" value={formData.city} onChange={handleInputChange} />
                                    </div>

                                    <div className="ls-form-group">
                                        <label>Pincode</label>
                                        <input
                                            type="text"
                                            name="pincode"
                                            placeholder="Enter pincode"
                                            value={formData.pincode}
                                            onChange={handleInputChange}
                                            required
                                        />

                                    </div>

                                </div>

                                <div className="ls-form-group">
                                    <label>Required Service</label>
                                    <input type="text" name="related_service" placeholder="What service do you need?" value={formData.related_service} onChange={handleInputChange} />
                                </div>

                                <div className="ls-form-group">
                                    <label>Add Note</label>
                                    <textarea name="remark" placeholder="Additional notes..." value={formData.remark} onChange={handleInputChange}></textarea>
                                </div>

                                <div className="ls-form-row">
                                    <div className="ls-form-group">
                                        <label>Reminder Date</label>
                                        <input type="date" name="remainder_date" value={formData.remainder_date} onChange={handleInputChange} />
                                    </div>

                                    <div className="ls-form-group">
                                        <label>Reminder Time</label>
                                        <input type="time" name="remainder_time" value={formData.remainder_time} onChange={handleInputChange} />
                                    </div>
                                </div>

                                <div className="ls-form-group">
                                    <label>Enquiry Source</label>
                                    <input type="text" name="enquiry_source" placeholder="Where did you hear about us?" value={formData.enquiry_source} onChange={handleInputChange} />
                                </div>

                                <div className="ls-form-group">
                                    <label>Type of Customer</label>
                                    <div className="ls-radio-group">
                                        <label className={`ls-radio-option ${formData.type_customer === "Business" ? "selected" : ""}`} onClick={handleInputChange}>
                                            <input type="radio" name="type_customer" value="Business" checked={formData.type_customer === "new"} readOnly /> Business
                                        </label>
                                        <label className={`ls-radio-option ${formData.type_customer === "Salaried" ? "selected" : ""}`} onClick={handleInputChange}>
                                            <input type="radio" name="type_customer" value="Salaried" checked={formData.type_customer === "Salaried"} readOnly /> Salaried
                                        </label>
                                    </div>
                                </div>





                                <div className="ls-modal-action">
                                    <button className="ls-modal-cancel" onClick={closeEnquiryModalEdit}>Cancel</button>
                                    <button className="ls-apply-btn">Submit</button>
                                </div>
                            </form>
                        </div>
                    </div>
                )
            }
            <ToastContainer />
        </>
    );
};

export default LeadsCards;
